<template>
  <div class="embroidery-main-view-preview small-centered text-center">
    <div id="snapshot-image-scene"></div>
    <base-spinner></base-spinner>
    <div class="row">
      <div :class="[{'columns small-6': itemsToPersonalize > 1}]" v-for="(item, index) in images" :key="item.caption" >
        <div :class="['embroidery-main-view-preview-crop-image',
          { 'side-model': isSideModel && !isUGCApplied},
          { 'tall-model': isTallModel},
          { 'ugc-applied': isUGCApplied && !isSideModel},
          { 'side-model-ugc': isUGCApplied && isSideModel},
          { 'embroidery-main-view-preview-first-image': index===0 && itemsToPersonalize > 1 },
          { 'embroidery-main-view-preview-single-image small-centered': itemsToPersonalize === 1}]"
        >
          <img
            :src="item.imgSrc"
            :alt="`${pdm.product_name} ${item.caption}`"
            :class="[
              'embroidery-main-view-preview-crop-image-img',
              { 'side-model': isSideModel && !isUGCApplied},
              { 'tall-model': isTallModel},
              { 'ugc-applied': isUGCApplied && !isSideModel},
              { 'side-model-ugc': isUGCApplied && isSideModel},
            ]"
            @load="imageIsLoaded"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseSpinner from '@/components/Spinner';

import imagesView from '@/mixins/Embroidery/ImagesView/index';

export default {
  name: 'imagesView',
  mixins: [imagesView],
	components: {
    baseSpinner
  },
};
</script>
